import React from 'react';
import { Card, Typography } from 'antd';
import { PanelStatusCircle } from './PanelStatusCircle';
import type { PanelStatusGridData } from '../types/dashboard.types';

const { Title } = Typography;

interface PanelStatusGridProps {
  readonly gridData: PanelStatusGridData;
}

const PANEL_STATUS_GRID_TITLE_LEVEL = 4;
const TWO_COLUMN_THRESHOLD = 5;

export const PanelStatusGrid: React.FC<PanelStatusGridProps> = ({
  gridData,
}) => {
  const panelCount = gridData.panels.length;
  const shouldUseTwoColumns = panelCount >= TWO_COLUMN_THRESHOLD;

  const renderPanelList = (): React.ReactNode => {
    if (panelCount === 0) {
      return (
        <div className="text-gray-400 text-sm py-4">
          登録されている盤がありません
        </div>
      );
    }

    return gridData.panels.map((panelData) => (
      <PanelStatusCircle
        key={`panel-${panelData.panelId.toPrimitive()}`}
        panelInfo={panelData}
      />
    ));
  };

  // SP: 常に1列、PC: 台数5以上なら2列
  const containerClassName = shouldUseTwoColumns
    ? 'flex flex-col md:grid md:grid-cols-2 md:gap-x-4'
    : 'flex flex-col';

  return (
    <Card className="h-full">
      <Title level={PANEL_STATUS_GRID_TITLE_LEVEL} className="mb-4">
        運用状態
      </Title>
      <div className={containerClassName}>
        {renderPanelList()}
      </div>
    </Card>
  );
};